// Admin copy of the web app's src/device/deviceErrors.js (card 540f21a4); keep the two in step.
// What an API error means on a paired event-day device (card 540f21a4): its
// access ended (forget only the device, never the whole browser), or its job
// doesn't include that, or the route isn't available on a device.
export function deviceErrorAction(error) {
  const status = error && error.response && error.response.status;
  const code = error && error.response && error.response.data && error.response.data.code;
  if (status === 401 && (code === 'LINK_ENDED' || code === 'LINK_INVALID')) return 'ended';
  if (status === 403 && code === 'FUNCTION_NOT_GRANTED') return 'notGranted';
  if (status === 404 && code === 'JOB_ROUTE_UNAVAILABLE') return 'unavailable';
  return 'none';
}

// Whether a failed request was a device's own (sent with the device token),
// decided from the request itself, not from storage: once one request ends
// the device, the others still in flight must not fall into the signed-in
// handling, which signs out and clears the browser (MC review 47396689
// R1-F3 / 56b15e4d R1-F1).
export function isDeviceRequest(error) {
  const headers = error && error.config && error.config.headers;
  if (!headers) return false;
  const token = typeof headers.get === 'function' ? headers.get('x-job-token') : headers['x-job-token'];
  return !!token;
}
